<template>
  <section>
    <div class="animated fadeIn h-100">
      <!-- <b-card class="h-30">
        <div class="card-body"> -->
          <h6>Please confirm the part information and click "Receive" to receive the item</h6>
					<br/>
					<b-row v-if="isRmaLineExist">
						<b-col cols="2">
							<dt>Receiving Line</dt>
							<dd>{{ rmaLineObj.id }}</dd>
						</b-col>
						<b-col cols="2">
							<dt>Part</dt>
							<dd>{{ rmaLineObj.partNumber }}</dd>
						</b-col>
						<b-col cols="2">
							<dt>Returning</dt>
							<dd>{{ rmaLineObj.qtyReturning }}</dd>
						</b-col>
						<b-col cols="2">
							<dt>Remaining</dt>
							<dd>{{ rmaLineObj.qtyReturning - rmaLineObj.qtyReceived }}</dd>
						</b-col>
						<b-col cols="2">
							<dt>Reason</dt>
							<dd>{{ rmaLineObj.rmaReasonName }}</dd>
						</b-col>
            <b-col cols="2">
							<dt>Comment</dt>
							<dd>{{ rmaLineObj.comments }}</dd>
            </b-col>
					</b-row>
        </div>
        <br/>
        <div>
          <rma-receive-details
							:receiveDetailsArr="receiveFormDetailsArr"
							:lineReceiveObj="lineReceiveObj"
							:ncmReportObj="ncmReportObj"
							:rmaLine="rmaLineObj"
							@receiveInput="setReceiveDetails"
							@quantityChange="onQuantityChange($event)"
					/>
        </div>
        <br/>
        <b-row>
					<b-col>
            <div></div>
						<div class="buttons-panel" v-if="!isReceivedSuccess">
							<b-button size="sm" variant="outline-danger" class="mr-1" @click="redirectToList">Cancel</b-button>
							<b-button size="sm" class="mr-1" @click="handleClear">Clear</b-button>
							<b-button variant="primary" size="sm" class="mr-1" @click="receiveItemDetails(false)" :disabled="isSaving">
                <i v-if="isSaving" class="fa fa-spinner fa-pulse fa-fw mr-1"></i>Receive</b-button>
							<b-button variant="primary" size="sm" class="mr-1" @click="receiveItemDetails(false, true)" :disabled="isSaving" v-if="isCredit">
                <i v-if="isSaving" class="fa fa-spinner fa-pulse fa-fw mr-1"></i>Receive & Create Credit</b-button>
							<b-button variant="primary" size="sm" @click="receiveItemDetails(true)" :disabled="isSaving">
                <i v-if="isSaving" class="fa fa-spinner fa-pulse fa-fw mr-1"></i>Receive & Close</b-button>
						</div>
						<div class="buttons-panel" v-else>
							<b-button size="sm" variant="outline-danger" class="mr-1" @click="redirectToList">Back to list</b-button>
						</div>
					</b-col>
				</b-row>
      <!-- </div>
     </b-card> -->
  </section>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import RmaReceiveDetails from '@/shared/components/RmaReceiveDetails';

export default {
  components: {
    RmaReceiveDetails
  },
  props: {
    rmaId: {
      type: [Number, String],
      default: 0
    },
    rmaLineObj: {
      type: Object,
      default: () => {}
		},
		isCredit: {
			type: Boolean,
			default: false
		}
  },
  data() {
    return {
      headerObj: {
				pageTitle: 'Receive Item',
				contactFullName: '',
				dateValue: '',
				statusName: ''
      },
      receiveFormDetailsArr: [],
			lineReceiveObj: {},
			ncmReportObj: {},
			isSaving: false,
			isReceivedSuccess: false
    }
  },
  computed: {
		...mapGetters('account', ['userId']),
    isRmaLineExist() {
      return Object.keys(this.rmaLineObj).length > 0;
    },
    sumReceiveQuantity() {
			return this.receiveFormDetailsArr.map(details => details.quantity).reduce((a, b) => a + b);
		},
  },
  methods: {
    ...mapActions('customerRmasLines', ['receiveRmaLine']),
    setReceiveDetails() {
			this.receiveFormDetailsArr = [];

			if (this.isRmaLineExist && this.lineReceiveObj.received > 0) {
				let receiveDetailObj = this.readyMadeReceiveDetailObj();

				receiveDetailObj.quantity = this.lineReceiveObj.received;

				this.receiveFormDetailsArr.push(receiveDetailObj);
				this.lineReceiveObj.showDetails = true;
			} else {
				this.lineReceiveObj.showDetails = false;
			}
    },
    onQuantityChange(val) {
			let received = parseInt(this.lineReceiveObj.received, 10);;

			if (this.sumReceiveQuantity < received && this.receiveFormDetailsArr[this.receiveFormDetailsArr.length -1].quantity > 0) {
				this.receiveFormDetailsArr.push(this.readyMadeReceiveDetailObj());
			} else if (this.sumReceiveQuantity === received
				&& (this.receiveFormDetailsArr[this.receiveFormDetailsArr.length -1].quantity == 0 || this.receiveFormDetailsArr[this.receiveFormDetailsArr.length -1].quantity == null)) {
				this.receiveFormDetailsArr.pop();
			} else if ((val == 0 || isNaN(val)) && this.receiveFormDetailsArr[this.receiveFormDetailsArr.length - 1].quantity == null && this.receiveFormDetailsArr.length != 1) {
				this.receiveFormDetailsArr.pop();
			}
		},
    readyMadeReceiveDetailObj() {
			return {
				id: 0,
				quantity: null,
				rejected: false,
				test: false,
				repack: false,
				cost: (this.isRmaLineExist) ? this.rmaLineObj.price : 0,
				dateCode: (this.isRmaLineExist) ? this.rmaLineObj.dateCode : null,
				lotCode: (this.isRmaLineExist) ? this.rmaLineObj.lotCode : null,
				revision: (this.isRmaLineExist) ? this.rmaLineObj.revision : null,
				conditionId: (this.isRmaLineExist) ? this.rmaLineObj.conditionId : 0,
				countryOfOriginId: (this.isRmaLineExist) ? this.rmaLineObj.countryOfOriginId : 0,
				vrmaReasonId: 0,
				comments: null,
				warehouseId: (this.isRmaLineExist) ? this.rmaLineObj.warehouseId : 0,
				location: (this.isRmaLineExist) ? this.rmaLineObj.location : null,
				isSplit: false,
				inventorySplits: [],
				images: []
			};
    },
    readyMadeLineReceiveObj() {
			return {
				received: (this.isRmaLineExist && this.rmaLineObj.qtyReturning > this.rmaLineObj.qtyReceived) ? (this.rmaLineObj.qtyReturning - this.rmaLineObj.qtyReceived) : 0,
				showDetails: (this.isRmaLineExist && this.rmaLineObj.qtyReturning > this.rmaLineObj.qtyReceived)
			}
		},
		readyMadeNCMReportObj() {
			return {
				id: 0,
				rmaLineId: (this.isRmaLineExist) ? this.rmaLineObj.id : 0,
				inspectedByUserId: this.userId,
				dateInspected: new Date(),
				partId: (this.isRmaLineExist) ? this.rmaLineObj.partId : 0,
				quantity: 0,
				ncmCodeId: 0,
				description: null,
				customerFound: false,
			}
		},
    redirectToList() {
			this.$emit('onRedirectToList');
    },
    handleClear() {
			this.receiveFormDetailsArr = [];
			this.ncmReportObj = this.readyMadeNCMReportObj();
			this.lineReceiveObj = this.readyMadeLineReceiveObj();
			if (this.isRmaLineExist && this.rmaLineObj.qtyReturning > 0) {
				this.setReceiveDetails();
			}
			this.isReceivedSuccess = (this.isRmaLineExist && this.rmaLineObj.qtyReceived >= this.rmaLineObj.qtyReturning);
    },
    isValidLines(lines) {
			let isValid = true;

			for (let i = 0; i < lines.length; i++) {
				isValid = lines[i].quantity != ""
					&& lines[i].warehouseId != 0
					&& (lines[i].location != null || lines[i].location != "")
			}

			return isValid;
		},
    async receiveItemDetails(isToRedirect, isCredit = false) {
			if (this.lineReceiveObj.received > this.rmaLineObj.qtyReturning) {
				alert("You cannot receive quantity that is greater than the returning quantity.");
				return;
			}

			let tempReceiveArr = this.receiveFormDetailsArr;

			// Auto disregards the newly added last row...
			if (tempReceiveArr.length > 1
				&& tempReceiveArr[tempReceiveArr.length -1].quantity == null) {
				tempReceiveArr.pop();
			}

			if (tempReceiveArr.length > 0 && !this.isValidLines(tempReceiveArr)) {
				alert("Please populate required fields.");
				return;
			}

			this.$snotify.info('Receiving in progress', 'Receive RMA Line');

			const receiveData = {
				...this.lineReceiveObj,
				rmaLineId: this.rmaLineObj.id,
				lines: tempReceiveArr
			}
			try {
        this.isSaving = true;
        const result = await this.receiveRmaLine(receiveData);
        this.isSaving = false;
        this.isReceivedSuccess = (result.status == 200);
        if (result.status == 200) {
          this.$snotify.success('Receiving Saved', 'Receive RMA Line');
          // this.lineReceiveObj.received = 0;
          // this.lineReceiveObj.showDetails = false;
					// this.rmaLineObj.qtyReturning = this.lineReceiveObj.quantity;
					this.$emit('received');
          if (isCredit) {
            this.$emit('onCredit');
          }
        }

        if (isToRedirect) {
          this.redirectToList();
        }
      } catch (e) {
        this.isSaving = false;
        /*console.log(e.message);*/
      }
		},
  },
  async mounted() {
    this.handleClear();
  }
}
</script>
